module.exports = __webpack_public_path__ + "img/img_index_link05.43ab2362.png";